import authHeader            from 'services/auth-header';
import WalletPasscodeService from 'services/wallet-passcode.service';

export default function walletUnlockHeader() {
  const token = WalletPasscodeService.unlockToken();

  return token ? { ...authHeader(), 'X-Wallet-Unlock-Token': token } : authHeader();
}
